const ALL_CONST = {
  welcome: "Bienvenue sur le passe-partout Kaiju React de Viamagus !",
  message: "Bonjour!! C'est chez moi - VIEW-1 !",
  "label.view1.post_heading": "En-tête de poste",
  "label.view1.post_description": "Description du poste",
  "label.view2.user_name": "Enter Nom",
  "label.user_name": "Enter Nom",
  "message.success": "Enter Name",
  "validator.mandatory": "C'est un champ obligatoire",
  "component.button.save": "sauvegarder",
  "component.button.cancel": "Annuler",

  // -------------------------------------------- Operation Center ---------------------------------------------//
  "heading.operationCenter.title": "Centre des opérations",
  "label.operationCenter.activities": "Activités",
  "label.operationCenter.activity.documents": "Documents",
  "label.operationCenter.activity.cersaiSearch": "Recherche CERSAI",
  "label.operationCenter.activity.ckycSearch": "Recherche CKYC",
  "label.operationCenter.activity.achMandate": "Mandat ACH",
  "label.operationCenter.activity.pdcCapture": "Saisie PDC",
  "label.operationCenter.activity.comingSoon": "Bientôt disponible",
  "label.operationCenter.tab.documentPack": "Dossier de documents",
  "label.operationCenter.tab.eSignature": "Signature électronique",
  "label.operationCenter.tab.history": "Historique",
  "heading.operationCenter.documentPack": "Dossier de documents",
  "description.operationCenter.documentPack":
    "Liste des documents selon l'avancement du prêt. Accessible après l'approbation financière.",
  "description.operationCenter.documentPackLocked":
    "Le dossier de documents devient accessible une fois l'approbation financière terminée.",
  "heading.operationCenter.eSignature": "Signature électronique",
  "description.operationCenter.eSignature":
    "Envoyez les documents générés pour signature électronique, suivez leur statut et téléchargez-les une fois signés.",
  "heading.operationCenter.history": "Historique",
  "description.operationCenter.history":
    "Documents téléchargés ou fusionnés pour ce prêt, avec l'auteur et la date.",
  "heading.operationCenter.previousVersions": "Versions précédentes — {{name}}",
  "heading.operationCenter.preview": "Aperçu — {{name}}",
  "heading.operationCenter.mergeDocuments": "Fusionner les documents",
  "description.operationCenter.merge.checking": "Vérification que chaque document est prêt à être fusionné…",
  "description.operationCenter.merge.generating":
    "Certains documents doivent d'abord être générés — {{ready}} sur {{total}} prêts. Ils seront fusionnés dès que tous seront prêts.",
  "description.operationCenter.merge.merging": "Fusion des documents…",
  "description.operationCenter.merge.ready": "Le document fusionné est prêt à être téléchargé.",
  "description.operationCenter.merge.order": "Les documents sont fusionnés dans l'ordre où vous les avez sélectionnés.",
  "description.operationCenter.merge.failed":
    "Ces documents n'ont pas pu être générés, la fusion ne peut donc pas être effectuée : {{names}}",
  "description.operationCenter.merge.timedOut":
    "La génération des documents prend plus de temps que prévu. Fermez cette fenêtre et réessayez la fusion plus tard.",
  "description.operationCenter.merge.statusFailed":
    "Impossible de vérifier l'état de la génération. Fermez cette fenêtre et réessayez la fusion plus tard.",
  "description.operationCenter.merge.changed":
    "Les documents ont changé pendant leur préparation. Fermez cette fenêtre et réessayez la fusion.",
  "description.operationCenter.merge.batchTooLarge": "Vous pouvez fusionner jusqu'à {{max}} documents à la fois.",
  "component.button.operationCenter.downloadMerged": "Télécharger le PDF fusionné",
  "heading.operationCenter.downloadDocuments": "Télécharger les documents",
  "description.operationCenter.download.starting": "Démarrage de la génération des documents…",
  "description.operationCenter.download.inProgress":
    "Génération des documents — {{ready}} sur {{total}} prêts. La génération continue même si vous fermez cette fenêtre.",
  "description.operationCenter.download.completed": "{{ready}} sur {{total}} documents sont prêts à être téléchargés.",
  "description.operationCenter.download.noneReady": "Aucun des documents sélectionnés n'a pu être généré.",
  "description.operationCenter.download.timedOut":
    "Cela prend plus de temps que prévu — {{ready}} sur {{total}} prêts. Vous pouvez télécharger les documents prêts maintenant, ou fermer et télécharger le reste plus tard.",
  "description.operationCenter.download.statusFailed":
    "Impossible de vérifier l'état de la génération — {{ready}} sur {{total}} prêts. Vous pouvez télécharger les documents prêts maintenant, ou fermer et réessayer plus tard.",
  "description.operationCenter.download.multipleFiles":
    "Les documents sont téléchargés ensemble dans un seul fichier ZIP.",
  "description.operationCenter.download.missing": "Ces documents n'ont pas pu être téléchargés : {{names}}",
  "description.operationCenter.download.batchTooLarge": "Vous pouvez télécharger jusqu'à {{max}} documents à la fois.",
  "description.operationCenter.download.success": "Documents téléchargés avec succès",
  "component.button.operationCenter.downloadReady": "Télécharger les prêts ({{count}})",
  "component.button.operationCenter.close": "Fermer",
  "description.operationCenter.download.saved":
    "Votre téléchargement a commencé. Si ce n'est pas le cas, enregistrez-le ci-dessous.",
  "component.button.operationCenter.save": "Enregistrer",
  "component.button.operationCenter.open": "Ouvrir",
  "description.operationCenter.download.openInstead":
    "Certains documents n'ont pas pu être ajoutés au téléchargement — ouvrez-les ci-dessus et enregistrez-les depuis la visionneuse.",
  "component.button.operationCenter.done": "Terminé",
  "description.operationCenter.generatingPreview": "Génération de l'aperçu…",
  "description.operationCenter.mergeSuccess": "Documents fusionnés avec succès",
  "description.operationCenter.fileUnavailable":
    "Impossible de générer le fichier. Veuillez réessayer.",
  "label.operationCenter.documentsSelected": "{{count}} documents sélectionnés",
  "label.operationCenter.menu.viewHistory": "Voir l'historique",
  "label.operationCenter.menu.viewDetails": "Voir les détails",
  "label.operationCenter.column.document": "Document",
  "label.operationCenter.column.appliesBecause": "S'applique car",
  "label.operationCenter.column.status": "Statut",
  "label.operationCenter.column.eSign": "Signature électronique",
  "label.operationCenter.column.generatedOn": "Généré le",
  "label.operationCenter.column.action": "Action",
  "label.operationCenter.column.documents": "Documents",
  "label.operationCenter.column.performedBy": "Effectué par",
  "label.operationCenter.column.performedOn": "Date",
  "label.operationCenter.action.downloaded": "Téléchargé",
  "label.operationCenter.action.merged": "Fusionné",
  "label.operationCenter.column.actions": "Actions",
  "label.operationCenter.pill.accessible": "Accessible",
  "label.operationCenter.pill.locked": "Verrouillé",
  "label.operationCenter.pill.required": "Obligatoire",
  "label.operationCenter.pill.optional": "Facultatif",
  "label.operationCenter.pill.standard": "Standard",
  "label.operationCenter.pill.conditional": "Conditionnel",
  "label.operationCenter.pill.applicable": "Applicable",
  "label.operationCenter.pill.notApplicable": "Non applicable",
  "label.operationCenter.pill.prefilled": "Prérempli",
  "label.operationCenter.pill.detailsSubmitted": "Détails soumis",
  "label.operationCenter.pill.detailsNeeded": "Détails requis",
  "label.operationCenter.state.generating": "Génération en cours",
  "label.operationCenter.state.generated": "Généré",
  "label.operationCenter.state.error": "Erreur",
  "label.operationCenter.status.current": "Actuelle",
  "component.button.operationCenter.mergeDocuments": "Fusionner les documents",
  "component.button.operationCenter.downloadSelected": "Télécharger la sélection",
  "component.button.operationCenter.completeDetails": "Compléter les détails",
  "heading.operationCenter.completeDetails": "Compléter les détails — {{name}}",
  "description.operationCenter.detailsSaved": "Détails enregistrés avec succès",
  "description.operationCenter.noDetailsRequired": "Aucun détail n'est requis pour ce document.",
  "placeholder.operationCenter.select": "Sélectionner",
  "component.button.operationCenter.submitDetails": "Soumettre",
  "component.button.operationCenter.moreDocuments": "+{{count}} de plus",
  "component.button.operationCenter.showLessDocuments": "Afficher moins",
  "description.operationCenter.noVersions": "Aucune version n'a encore été générée pour ce document.",
  "validator.dynamicForm.minLength": "Doit contenir au moins {{value}} caractères",
  "validator.dynamicForm.maxLength": "Doit contenir au plus {{value}} caractères",
  "validator.dynamicForm.number": "Saisissez un nombre valide",
  "validator.dynamicForm.min": "Doit être au moins {{value}}",
  "validator.dynamicForm.max": "Doit être au plus {{value}}",
  "validator.dynamicForm.minDate": "Doit être le {{value}} ou après",
  "validator.dynamicForm.maxDate": "Doit être le {{value}} ou avant",
  "validator.dynamicForm.pattern": "Format invalide",
  "validator.dynamicForm.allowedValues": "Sélectionnez une option valide",
};

export default ALL_CONST;
